import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'
export interface LeakQueryParams {
  /** 终端设备id */
  device_id: string
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number,
  /** 是否高危漏洞 */
  is_high_risk?: boolean,
}
export interface RepairQueryParams {
  /** 补丁编号 */
  kb_numbers: string[]
  /** 选择类型,0-仅指定漏洞，1-全部高危 */
  select_type: number
  /** 终端设备id */
  device_id: string
}

export interface TLeakList {
  /** 补丁编号 */
  kb_number: string
  /** 补丁描述 */
  kb_desc: string
  /** 补丁发布日期 */
  kb_pub_date: string
  /** 漏洞类型 */
  leak_type: string
  /** 漏洞级别 */
  warn_level: number
  /** 补丁大小 */
  size: string
  /** 修复状态 "未修复" 0"修复中" 1*/
  fix_status: number
}
@Injectable()
export class LeakTerminalService {
  constructor (private http: Http) {}

  @ParamsClean()
  getSingleTerminalLeaks (data: LeakQueryParams) {
    return this.http.post<{
      list: TLeakList[]
      total: number
    }>('/leak/terminal-view/get-leaks', data)
  }

  RepairTerminal (data: RepairQueryParams) {
    return this.http.post<void>('/leak/terminal-view/repair', data)
  }
}

